import { baseThemeValues } from 'constants/common';

export const formNavigationTheme = {
  base: {
    bg: 'palette.transparent',
    borderRadius: '8px',
    fontFamily: baseThemeValues.inherit,
    fontSize: '14px',
    fontWeight: 500,
    text: 'palette.tertiary.50',
  },
  hover: {
    bg: 'palette.surface.4',
    borderRadius: '8px',
    fontFamily: baseThemeValues.inherit,
    fontSize: '14px',
    fontWeight: 500,
    text: 'palette.tertiary.95',
  },
};
